import { useContext } from 'react';
import { GridContext } from '../contexts/GridContext';

function useGrid() {
  const context = useContext(GridContext);
  if (context === null) {
    throw new Error('useGrid must be used within a GridProvider');
  }
  return context;
}

export default useGrid;
